module.exports = __webpack_public_path__ + "static/logo-white-b36323385dd03295f3ee76c4b3fecf6a.png";